<template>
  <div>
    <list
      ref="list"
      unit="销货退货单"
      row-key="Id"
      :page="page"
      :query-params="params"
      :show-checkbox="true"
      :show-query="showQuery"
      @reset-query="$emit('reset-select')"
      :reRowClick="true"
      :get-row-click-func="myRowClick"
      :get-data-func="getDataFunc"
      :summaryMethod="summaryFunc"
      :show-summary="summaryShow"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"> </slot>
      </template>
      <template slot="query">
        <el-form-item label="客户名称">
          <customer @restaurants="setSupplier" :state="params.CustomerName" />
        </el-form-item>
        <el-form-item label="单据编号">
          <el-input clearable v-model="params.DocNo" placeholder="请输入单据编号" />
        </el-form-item>
        <el-form-item label="订单编号">
          <el-input clearable v-model="params.OrderNo" placeholder="请输入订单编号" />
        </el-form-item>
        <el-form-item label="单据状态">
          <el-select v-model="params.Status" placeholder="请选择" clearable>
            <el-option label="草稿" :value="0"></el-option>
            <el-option label="未生效" :value="1"></el-option>
            <el-option label="已生效" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="出库状态">
          <el-select v-model="params.OutStatus" placeholder="请选择" clearable>
            <el-option label="未出库" :value="0"></el-option>
            <el-option label="部分出库" :value="1"></el-option>
            <el-option label="已出库" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开票状态">
          <el-select v-model="params.InvoiceStatus" placeholder="请选择" clearable>
            <el-option label="未完成" :value="1"></el-option>
            <el-option label="已完成" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收款状态">
          <el-select v-model="params.ReceiptStatus" placeholder="请选择" clearable>
            <el-option label="未收款" :value="0"></el-option>
            <el-option label="部分收款" :value="1"></el-option>
            <el-option label="已收款" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单据日期">
          <el-date-picker
            v-model.trim="params.DocDateStart"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
          <span style="margin:0 10px;">-</span>
          <el-date-picker
            v-model.trim="params.DocDateEnd"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="所属机构">
              <el-select size="mini" v-model="params.DpId" placeholder="请选择机构" clearable>
         
                  <el-option v-for="(item,key) in DpList" :key="key" :label="item.DpName" :value="item.DpId"></el-option>
           
              </el-select>
            </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="DpName" label="所属机构" min-width="100px" />
        <el-table-column prop="DocNo" label="单据编号" min-width="110px" />
        <el-table-column prop="DocDate" label="单据日期" min-width="110px">
          <template slot-scope="{row}">{{row.DocDate.split(" ")[0]}}</template>
        </el-table-column>
        <el-table-column prop="CustomerName" label="客户名称" min-width="110px" />
        <el-table-column prop="Amount" label="退货金额">
          <template slot-scope="{row}">{{$commonJs.toThousands(row.Amount)}}</template>
        </el-table-column>
        <el-table-column prop="OrderNo" label="订单编号" min-width="110px" />
        <el-table-column prop="ClerkName" label="业务员" />
        <el-table-column prop="Status" label="单据状态">
          <template slot-scope="{row}">
            <span v-if="row.Status==0">草稿</span>
            <span v-else-if="row.Status==1">未生效</span>
            <span v-else>已生效</span>
          </template>
        </el-table-column>
        <el-table-column prop="OutStatus" label="退库状态">
          <template slot-scope="{row}">
            <span v-if="row.OutStatus==0">未退库</span>
            <span v-else-if="row.Status==1">部分退库</span>
            <span v-else>已退库</span>
          </template>
        </el-table-column>
        <el-table-column prop="ReceiptStatus" label="退款状态">
          <template slot-scope="{row}">
            <span v-if="row.ReceiptStatus==0">未退款</span>
            <span v-else-if="row.ReceiptStatus==1">部分退款</span>
            <span v-else>已退款</span>
          </template>
        </el-table-column>
        <el-table-column prop="InvoiceStatus" label="开票状态">
          <template slot-scope="{row}">
            <span v-if="row.InvoiceStatus==0">未完成</span>
            <span v-else>已完成</span>
          </template>
        </el-table-column>
        <slot name="column"></slot>
      </template>
    </list>
 
  </div>
</template>
<script>
import customer from "@/components/common/customer/customer";
import listMixin from "@/mixins/list";
import list from "@/components/common/list"; 

export default {
  mixins: [listMixin],
  components: { list,  customer },
  beforeMount() {
    this.cApi.list({ pageSize: 100, pageIndex: 1 }).then((res) => {
      this.cList = res.Data;
      sessionStorage.setItem("cList", JSON.stringify(res.Data));
    });
  },
  data() {
    return {
      api: require("@/api/sale/saBackDoc").default,
      cApi: require("@/api/ba/tradeUnit").default,
      dpApi: require("@/api/ent/dp").default,
      cList: [],
      params: {
        DocNo: "",
        OrderNo: "",
        Score: null,
        ScoreText: "",
        AddTime: "",
        Status: null,
        OutStatus: null,
        DocDateStart: this.$commonJs.getDayOffset(-30),
        DocDateEnd: this.$commonJs.getDayOffset(0),
        FreightMode: null,
        FreightNo: "",
        InvoiceStatus: null,
        ReceiptStatus: null,
        CustomerId: null,
        CustomerName: "",
        DpId:null//所属门店
      },
      CustomerName: "",
      DpList:[],
      summaryShow: false,
      total:null
    };
  },
  created(){
    this.dpApi.parentList({DpType:1}).then(res => {
       
       this.DpList = res.Data;
     })
  },
  methods: {
    getDataFunc(params) {
      return new Promise((resolve, reject) => {
        this.api.list(params).then(res => {
          let times = Math.ceil(res.Count / params.pageSize);
          //判断是否最后一页
          if (times == params.pageIndex) {
            this.api.listTotal(params).then(res => {
              if (res.Code == 0 && res.Data) {
                this.total = res.Data[0];
                this.summaryShow = true;
              } else {
                this.summaryShow = false;
              }
            })
          } else {
            this.summaryShow = false;
          }
          resolve(res);
        })
      })
    },
    summaryFunc(param) {
      const { columns, data } = param;
      var fields = ['Amount']; //需要合计的字段
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        var field = fields.find(x => x == column.property);
        if (field) {
          console.log(field, index);
          sums[index] = "";
          if (this.total) {
            sums[index] = this.total[field].toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          }
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
    setSupplier(data) {
      this.params.CustomerId = data.TradeUnitId;
      this.params.CustomerName = data.TradeUnitName;
    },
    myRowClick(row, column, e) {
      this.$emit("loading");
      this.api.info(row.DocId).then((res) => {
        this.$emit("setDetails", res.Data.Goods, row);
        this.$emit("loading");
      });
    },  
  },
};
</script>